import { asyncScheduler, Subscription } from 'rxjs';
import { finalize, map, takeUntil, throttleTime } from 'rxjs/operators';
import { IBackgroundService } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { INotificationsPoolService, NOTIFICATIONS_POOL_SERVICE } from '../notifications-pool';
import { IPersistenceAdapterService, PERSISTENCE_ADAPTER_SERVICE } from '../../message-adapters/persistence-adapter';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { typedGet } from '../../../helpers/object-utils';

const SAVE_READ_NOTIFICATIONS_INTERVAL = 3_000;

@injectable()
export class NotificationsReadSaveService implements IBackgroundService {

    @inject(PERSISTENCE_ADAPTER_SERVICE) private readonly adapter: IPersistenceAdapterService;
    @inject(NOTIFICATIONS_POOL_SERVICE) private readonly notificationsPoolService: INotificationsPoolService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    private subscription: Subscription;

    start(): void {
        this.subscription ?? (this.subscription = this.notificationsPoolService.notificationsPoolObservable().pipe(
            takeUntil(this.sessionLifeCycle.destroyObservable()),
            finalize(() => this.subscription = null),
            map(notifications =>
                notifications
                    .filter(notification => notification.haveBeenSeen)
                    .map(typedGet('id')),
            ),
            map(notifications => JSON.stringify(notifications)),
            throttleTime(SAVE_READ_NOTIFICATIONS_INTERVAL, asyncScheduler, { leading: false, trailing: true }),
        ).subscribe(data => this.adapter.save({ 'readNotifications': data })));
    }
}
